import {Component, HostBinding, Input} from '@angular/core';

@Component({
    selector: 'vui-injection',
    templateUrl: './injection.component.html',
    styleUrls: ['./injection.component.scss']
})
export class InjectionComponent {
    @HostBinding('class.loaded') @Input() public loaded: boolean;
}
